import * as React from 'react';
import AppView from '../../views/custom/custom-app.view'; 
import Responsive from '../../components/responsive'; 
import { CalendarDeviceMode } from '../../classes/calendar';
import { CalendarViewMode } from '../../classes/calendar';
import { ICalendarAppText } from '../../custom/classes/calendar-text';

import { ICalendarAppState } from '../../redux-state';
import { connect } from 'react-redux';

interface AppExternalProps {

}

interface StateToProps {
    calendarDeviceMode: CalendarDeviceMode;
    calendarViewMode: CalendarViewMode;
    text: ICalendarAppText;
    filtersAmount: number;
}
 
export type AppProps = AppExternalProps & StateToProps;
export type AppState = { filtersShouldStick: boolean, filtersAmount:number }

export class AppComponent extends React.Component<AppProps, any> {
    constructor(props: AppProps) {
        super(props);
    }

    render() {
        return (
            <>
                <Responsive />
                <AppView {...this.props} />
            </>
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: AppExternalProps): StateToProps {
    return {
        calendarDeviceMode: state.calendarSettings.calendarDeviceMode,
        calendarViewMode: state.calendarSettings.calendarViewMode,
        text: state.calendarText,
        filtersAmount: state.calendar.eventFilter.length 
    }
}

export default connect<StateToProps>(mapStateToProps)(AppComponent);
